import React from 'react';
import styled from 'styled-components';

import { useSelector } from 'react-redux';
import moment from 'moment';
import SVG from 'react-inlinesvg';

import svgCheckMark from '@common/assets/svg/icon-check.svg';
import {
  COLOR_TURQUOISE,
  COLOR_TURQUOISE_020,
} from '@common/assets/styles/colors';

import { TRootState } from '@store/root-reducer';
import { RecapSC } from '@views/order-recap/order-recap';
import { isEmptyOrWhiteSpace } from '@common/utils/common';
import PAGE_STYLES from '../../helpers/page-styles';

const FinalRecapSC = styled(RecapSC)`
  ${PAGE_STYLES};

  .check-wrapper {
    width: 70px;
    height: 70px;
    border-radius: 35px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 32px;

    background: ${COLOR_TURQUOISE_020};

    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 44px;
      height: 29px;

      g {
        stroke: ${COLOR_TURQUOISE};
      }
    }
  }
`;

const FinalRecap = () => {
  const order = useSelector((store: TRootState) => store.userInterface.order);
  const {
    expert: { name: expertName },
    datetime: { day, month, year, time },
    expertise: { name: expertiseName },
    medicalInstitution: {
      name: medicalInstitutionName,
      address: medicalInstitutionAddress,
    },
    note,
  } = order;

  const date = `${year}-${month}-${day}`;

  return (
    <FinalRecapSC>
      <div className={'header'}>
        <h4>Ďakujeme za objednávku u lekára {expertName}</h4>
      </div>
      <div className={'content'}>
        <div className="check-wrapper">
          <SVG src={svgCheckMark} />
        </div>
        <span className="order-date">
          {moment(`${date} ${time}`).format('dddd Do MMMM YYYY')}
        </span>
        <span className="order-time">
          {moment(`${date} ${time}`).format('HH:mm')} hod
        </span>

        <div className="order-place">
          <span className="order-place__name">{medicalInstitutionName}</span>
          <span className="order-place__address">
            {medicalInstitutionAddress}
          </span>
        </div>

        <span className="expert-expertise">{expertiseName}</span>
        {note && isEmptyOrWhiteSpace(note) && (
          <span className="order-note">
            <em>Poznámka: "{note}"</em>
          </span>
        )}
      </div>
    </FinalRecapSC>
  );
};

export default FinalRecap;
